export default __webpack_public_path__ + "static/circle-tick-c256f8d7131305beec34f81e329747a6.svg";